<template>
  <div class="register">
    <h1 class="center-text">Create An Account</h1>
    <form @submit.prevent="createUser">
      <div class="form-300 center-element">
        <div v-if="apiError" class="error">
          Error: {{ apiErrorMessage }}<br />
        </div>
        <div v-if="isError" class="error">Error with form<br /></div>
        <label>Full Name</label><br />
        <input
          v-model.trim="user.full_name"
          type="text"
          placeholder="First and Last Name"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'First and Last Name'"
          required
        /><br />
        <label>Email</label><br />
        <input
          v-model.trim="user.email"
          type="text"
          placeholder="Email"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Email'"
          required
        /><br />
        <div v-if="isEmailError" class="error">
          {{ errorEmailMessage }}<br />
        </div>
        <label>Password</label><br />
        <input
          v-model.trim="user.password"
          type="password"
          placeholder="Must be 8 characters or more"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Must be 8 characters or more'"
          required
        /><br />
        <div v-if="isPasswordError" class="error">
          {{ errorPasswordMessage }}
        </div>
        <button type="submit" class="button button-300">Register</button>
      </div>
    </form>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {
      user: {
        full_name: "",
        email: "",
        password: ""
      },
      isError: false,
      isPasswordError: false,
      isEmailError: false,
      errorEmailMessage: "",
      errorPasswordMessage: ""
    };
  },
  computed: {
    // registerAPIError () {
    //   return this.$store.getters.registerAPIError;
    // },
    apiError() {
      return this.$store.getters.apiError;
    },
    apiErrorMessage() {
      return this.$store.getters.apiErrorMessage;
    }
  },
  created() {
    this.isError = false;
    this.isPasswordError = false;
    this.isEmailError = false;
    this.errorEmailMessage = "";
    this.errorPasswordMessage = "";
    // this.$store.dispatch('setRegisterAPIErrorFalse');
    this.$store.dispatch("resetAllAPIErrorAndMessages");
  },
  methods: {
    createUser: function(e) {
      // this.$store.dispatch('setRegisterAPIErrorFalse');
      this.$store.dispatch("resetAllAPIErrorAndMessages");
      this.isError = false;
      this.isPasswordError = false;
      this.isEmailError = false;
      this.user.email = this.user.email.trim().toLowerCase();
      this.user.password = this.user.password.trim();

      // let rePattern = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
      let reEmailFormat = /^[^@|^\s]+@\S+\.\S+/;
      let resultEmailFormat = reEmailFormat.test(this.user.email);
      let resultPasswordLength = this.user.password.length;
      if (!resultEmailFormat) {
        this.isError = true;
        this.isEmailError = true;
        this.errorEmailMessage = "Invalid email entered";
      }
      if (resultPasswordLength < 8) {
        this.isError = true;
        this.isPasswordError = true;
        this.user.password = "";
        this.errorPasswordMessage =
          "Password length must be 8 characters or longer";
      }
      if (!this.isError) {
        this.$store.dispatch("createUser", this.user);
      }
    }
  }
};
</script>
<style></style>
